exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-7f98c27e] {\n  background: #ebeff3;\n  border-radius: 10px;\n}\n.card .bar[data-v-7f98c27e] {\n    width: 100%;\n    height: 10px;\n    border-radius: 10px 10px 0 0;\n}\n.card .card-header[data-v-7f98c27e] {\n    border-radius: 10px 10px 0 0;\n    background-color: #e7e7e7;\n    padding: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f98c27e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/settings/docEscalationTime.vue
// module id = 1380
// module chunks = 2